import { BusinessObjectBase, ModelBase, ObservableCollection } from '@skylab-shared/core';
import { DocumentItemModel } from '@skylab-shared/dataModel';
import { ContextKeys } from '../../common/context-keys';
import { CommunityTransactionForSaleQuery } from '../../community-transaction/queries/community-transaction-for-sale.query-base';
import { ProductRepositoryContract } from '../../shared-business-temporary-contracts';
import { VatRateForSaleQuery } from '../../vat/queries/vat-rate-for-sale.query-base';

interface ModelPart extends ModelBase {
    communityTransactionId: number;
    items: ObservableCollection<DocumentItemModel>;
}

export abstract class CommunityTransactionForSaleMixin<TModel extends ModelPart> extends BusinessObjectBase<TModel>  {
    protected productRepository: ProductRepositoryContract;

    public async setComunityTransactionAsync(communityTransactionId: number): Promise<void> {
        this.model.communityTransactionId = communityTransactionId;

        if (this.isWstoOssDocument) return;

        const { defaultVatRateId: defaultVatRateForCommunityTransactionId } = this.localContext
            .firstPreloaded(CommunityTransactionForSaleQuery, { id: communityTransactionId });
        if (!defaultVatRateForCommunityTransactionId) {
            await Promise.all(this.model.items.map(item => this.setDefaultDocumentItemVatRateAsync(item)));
        } else {
            this.model.items.forEach(item => item.vatRateId = defaultVatRateForCommunityTransactionId);
        }
    }

    private async setDefaultDocumentItemVatRateAsync(item: DocumentItemModel): Promise<void> {
        if (item.productId === null) {
            const vatRate = this.localContext.firstPreloaded(VatRateForSaleQuery, { default: true });
            item.vatRateId = vatRate.id;
        } else {
            const product = await this.localContext.getAsync(ContextKeys.product(item.productId), () => this.productRepository.findAsync(item.productId!));
            item.vatRateId = product.vatRateId;
        }
    }

    public get isWstoOssDocument(): boolean {
        const { id } = this.localContext.firstPreloaded(CommunityTransactionForSaleQuery, { symbol: 'WSTO-OSS' });
        return (this.model.communityTransactionId === id);
    }

    public get isWstoOssEditedDocument(): boolean {
        return this.model.isPersistent && this.isWstoOssDocument;
    }
}
